import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ApiService } from '../../../services/api/api.service';
import { FilterService } from '../../../services/filter/filter.service';

export const addUserTeam = createAsyncThunk('DASHBOARD_TEAM/ADD_USER',
  async ({vendorId, payload}, thunkApi) => {
    try {
      const response = await ApiService.post(`/vendor/admin/${vendorId}/users/user`, payload);
      let data = await response.data;
      if (response.status === 200) {
        return data;
      }
      return thunkApi.rejectWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  });

export const getTeamUsers = createAsyncThunk('DASHBOARD_TEAM/GET_USERS',
  async ({vendorId, filter}, thunkApi) => {
    try {
      let _url = FilterService.addFilter({url: `/vendor/admin/${vendorId}/users/`, filter});
      const response = await ApiService.get(_url);
      let data = await response.data.filter((teamUser) => {
        return teamUser.roles.includes('ROLE_VENDOR_HANDLER');
      });
      if (response.status === 200) {
        return data;
      }
      return thunkApi.rejectWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  });

export const deleteTeamUser = createAsyncThunk('DASHBOARD_TEAM/DELETE_USER',
  async ({userId, vendorId, payload}, thunkApi) => {
    try {
      const response = await ApiService.delete(`/vendor/admin/${vendorId}/users/${userId}`, payload);
      let data = await response.data;
      if (response.status === 200) {
        return data;
      }
      return thunkApi.rejectWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  });

const initialState = {
  isFetching: false,
  isSuccess: false,
  isError: false,
  users: [],
  errorMessage: '',
};

export const dashboardTeamSlice = createSlice({
  name: 'DASHBOARD_TEAM',
  initialState: initialState,
  extraReducers: {
    [addUserTeam.fulfilled]: (state) => {
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [addUserTeam.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload?.errors?.user || '';
    },
    [addUserTeam.pending]: (state) => {
      state.isFetching = true;
    },

    [getTeamUsers.fulfilled]: (state, { payload }) => {
      state.users = payload;
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [getTeamUsers.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload?.message || '';
    },
    [getTeamUsers.pending]: (state) => {
      state.isFetching = true;
    },

    [deleteTeamUser.fulfilled]: (state) => {
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [deleteTeamUser.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload?.message || '';
    },
    [deleteTeamUser.pending]: (state) => {
      state.isFetching = true;
    },
  }
});
